/**************************************************
 * Nombre:       Tarjeta_Espeficacion
 * Descripcion:
 *
 * Libreria:
 *
 * Tiempo:     5 Hr
 **************************************************/
import {Grid, Typography,IconButton,Collapse} from "@mui/material";
import {Add} from '@mui/icons-material'
import {useState} from "react";

const Tarjeta_Espeficacion = ({it,index}) => {
    const [open, setOpen] = useState(false);

    return (
        <Grid
            container
            justifyContent={'flex-start'}
            alignItems={'center'}
            size={{xs: 12, sm: 12, md: 12}}
            sx={{px: 4}}
        >

            <Grid container size={{xs: 11, sm: 11, md: 11}} sx={{justifyContent: 'flex-start'}}>
                <Typography sx={{fontWeight: 600}}>
                                <span style={{fontWeight: 800, marginRight: 5}}>
                                    {index + 1}.
                                </span>
                    {it.nombre}
                </Typography>
            </Grid>

            <Grid container size={{xs: 1, sm: 1, md: 1}} sx={{justifyContent: 'flex-start'}}>
                <IconButton>
                    <Add onClick={() => setOpen(!open)}
                         sx={{width: 18, height: 18}}
                    />
                </IconButton>
            </Grid>

            <Collapse in={open} sx={{width: '100%'}}>
                <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'flex-start'}}>
                    <Typography>
                        {it.descripcion}
                    </Typography>
                </Grid>
            </Collapse>


        </Grid>
    )

}
export default Tarjeta_Espeficacion